import { socialPlanListItemSchema, type SocialPlanListItem } from '@growup/site-shared';
import { Button, Card, Notice } from '@growup/ui';
import { useEffect, useState } from 'react';
import { z } from 'zod';

import { getJson, messageOf } from '../api';
import { periodLabel, Progress } from './PlansView';

/**
 * Eventos > Conteudo (RF-RS12): o resumo dos planos de redes sociais ligados
 * ao evento. Mexer no plano e em Redes sociais.
 */
export function EventContentView({
  eventId,
  onOpenPlan,
}: {
  eventId: string;
  /** Sem acesso a Redes sociais, nao ha botao. */
  onOpenPlan?: ((planId: string) => void) | undefined;
}) {
  const [plans, setPlans] = useState<SocialPlanListItem[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getJson(`/api/site/events/${eventId}/social-plans`, z.array(socialPlanListItemSchema))
      .then(setPlans)
      .catch((e: unknown) => setError(messageOf(e)));
  }, [eventId]);

  return (
    <Card headingLevel={2} title="Conteúdo para as redes sociais">
      <div className="flex flex-col gap-3">
        <p className="text-gu-ink-muted">
          Os planos de conteúdo ligados a este evento. Criam-se e gerem-se em Redes sociais &gt;
          Planos, pelo Gestor de Redes Sociais.
        </p>
        {error ? <Notice tone="danger">{error}</Notice> : null}
        {plans === null && !error ? <p>A carregar…</p> : null}
        {plans?.length === 0 ? <p>Nenhum plano ligado a este evento.</p> : null}
        {plans?.map((p) => (
          <div key={p.id} className="flex flex-col gap-2 border-2 border-gu-line p-3">
            <div className="flex flex-wrap items-center justify-between gap-2">
              <span className="font-semibold">{p.name}</span>
              {onOpenPlan ? (
                <Button size="sm" variant="secondary" onClick={() => onOpenPlan(p.id)}>
                  Abrir em Redes sociais
                </Button>
              ) : null}
            </div>
            <span className="text-caption text-gu-ink-muted">
              {periodLabel(p)} ·{' '}
              {p.members.length > 0 ? p.members.map((m) => m.login).join(', ') : 'sem influencers'}
            </span>
            <Progress summary={p.summary} />
          </div>
        ))}
      </div>
    </Card>
  );
}
